module.exports = __webpack_public_path__ + "img/5.5dfd9284.png";